// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Composite API
 * HTTP API for managing Neo4j composite database instances.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const ModelsProvider = {
  ProviderGCP: 'gcp',
  ProviderAWS: 'aws',
  ProviderAzure: 'azure',
} as const;
export type ModelsProvider =
  (typeof ModelsProvider)[keyof typeof ModelsProvider];

export function instanceOfModelsProvider(value: any): boolean {
  for (const key in ModelsProvider) {
    if (Object.prototype.hasOwnProperty.call(ModelsProvider, key)) {
      if (ModelsProvider[key as keyof typeof ModelsProvider] === value) {
        return true;
      }
    }
  }
  return false;
}

export function ModelsProviderFromJSON(json: any): ModelsProvider {
  return ModelsProviderFromJSONTyped(json, false);
}

export function ModelsProviderFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ModelsProvider {
  return json as ModelsProvider;
}

export function ModelsProviderToJSON(value?: ModelsProvider | null): any {
  return value as any;
}

export function ModelsProviderToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): ModelsProvider {
  return value as ModelsProvider;
}
